import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    url: String,
    notifyUrl: String,
    tnId: Number,
    valueReportId: Number,
  };

  async handleClick(event) {
    event.preventDefault();

    try {
      // First, create the notification
      const response = await fetch(this.notifyUrlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
            .content,
        },
        body: JSON.stringify({
          cta_button: "start_application",
          tn_id: this.tnIdValue,
          value_report_id: this.valueReportIdValue,
        }),
      });

      if (response.ok) {
        // After successful notification, redirect to the application URL
        window.location.href = this.urlValue;
      } else {
        // If notification fails, still redirect but log the error
        console.error("Failed to create notification");
        window.location.href = this.urlValue;
      }
    } catch (error) {
      // If there's an error, still redirect but log it
      console.error("Error creating notification:", error);
      window.location.href = this.urlValue;
    }
  }
}
